/* global submitReview */

(function ($) {
	var defaults = {
		mobileDisplay: false,
		navBarId: 'navbar',
		progressBarColor: '#005BBB',
		showProgressBarLabels: true,
		surveyQuestionSections: [],
		questionsPerPage: 1,
		currentQuestions: [],
		onError: $.noop,
		onRendered: function () {
			// Callback triggered immediately after rendering
		},
		onInit: function () {
			// Callback triggered immediately after initialization
		},
		onPageChange: function () {
			// Callback triggered when a page is changed
		},
		onChangingPage: function () {
			// Callback triggered before page is changed
			return true;
		},
		labels: {
			back: 'back',
			next: 'next',
			start: 'start',
			finish: 'finish',
			progression: '{status}% progression',
			invalid_fields: 'wrong fields'
		},
		navBarTmpl: $.template('' + '<div class="container">' + '<a class="trustyou-ui btn l-left back_button_top">${back}</a>' + '<a class="trustyou-ui btn l-right next_button_top">${next}</a>' + '<p class="progress-bar-status">' + '${progression}' + '</p>' + '<div class="trustyou-ui bar-chart">' + '<div class="value" style="width: 0%;"></div>' + '</div>' + '</div>'),
		surveyPaginatorTmpl: $.template('' + '<section class="pagination survey-paginator-controls l-align-center">' + '<a class="trustyou-ui btn l-left back_button">${back}</a>' + '<a class="trustyou-ui btn l-right next_button">${next}</a>' + '</section>')
	};

	if ($.fn.SurveyPaginator) {
		throw new Error('SurveyPaginator plugin is already defined');
	}

	$.fn.SurveyPaginator = function () {
		return $.extend(this, $.fn.SurveyPaginator.API);
	};

	$.fn.SurveyPaginator.API = {
		init: function (params) {
			var el = this;

			params = $.extend(true, {}, defaults, params);

			// don't allow 0 or null for questions per page
			if (!params.questionsPerPage) {
				params.questionsPerPage = 1;
			}

			if (!params.currentQuestions) {
				params.currentQuestions = [];
			}

			el.addClass('survey-paginator');

			if (params.mobileDisplay) {
				el.addClass('mobile-display');
			}

			el._surveyPaginatorData(params);

			$('#' + params.navBarId).html($.tmpl(params.navBarTmpl, {
				progression: params.labels.progression.replace('{status}', el._getStatusPercentage()),
				back: params.labels.back,
				next: params.labels.next
			}));

			this.refresh();

			params.onInit();

			return this;
		},
		initializeProgress: function () {
			// wait a few seconds so that the header image is loaded
			setTimeout(function () {
				var navbar = $('#navbar');
				var navbarPos = navbar.offset();

				$(window).bind('scroll', function () {
					if ($(window).scrollTop() >= navbarPos.top) {
						navbar.addClass('is-fixed');
					} else {
						navbar.removeClass('is-fixed');
					}
				});
			}, 2000);
		},
		changePage: function (direction) {
			var el = this;
			var params = el._surveyPaginatorData();

			el._progressBar();
			el._progressBarStatus();

			// hide currently shown questions
			el.hideQuestions();

			// get new set questions with visible content to display
			if (direction) {
				params.currentQuestions = el._nextQuestions();
			} else {
				params.currentQuestions = el._previousQuestions();
			}

			el.showQuestions();

			el.updatePaginationControls();

			el.updateWelcomeSection();

			el.updateProgressControls(el._getStatusPercentage());

			$('html, body').animate({
				scrollTop: $('main').offset().top + 50
			}, 'normal');

			return params.onPageChange();
		},
		updateWelcomeSection: function () {
			var el = this;
			if (!el._hasPrevious()) {
				el.find('.welcome').show();
			} else {
				el.find('.welcome').hide();
			}
		},
		updatePaginationControls: function () {
			var el = this;
			var params = el._surveyPaginatorData();
			var paginatorControls = el._controls();
			var backButton = paginatorControls.children('.back_button');
			var nextButton = paginatorControls.children('.next_button');
			var backButtonTop = $('#' + params.navBarId).find('.back_button, .back_button_top');
			var nextButtonTop = $('#' + params.navBarId).find('.next_button, .next_button_top');

			if (!el._hasPrevious()) {
				backButton.addClass('is-hidden');
				backButtonTop.addClass('is-hidden');
			} else {
				backButton.removeClass('is-hidden');
				backButtonTop.removeClass('is-hidden');
			}

			if (!el._hasNext()) {
				nextButton.addClass('is-hidden');
				nextButtonTop.addClass('is-hidden');

				el.find('.' + params.submitControlClass).removeClass('is-hidden');
			} else {
				nextButton.removeClass('is-hidden');
				nextButtonTop.removeClass('is-hidden');

				el.find('.' + params.submitControlClass).addClass('is-hidden');
			}
			// to prevent page jump in FF, IE need to hide after showing other questions (not vise versa)
			el.find('.parent_not_selected').css('display', 'none');
		},
		updateProgressControls: function (percentage) {
			this._progressBar().css('width', percentage + '%');
			this._progressBarStatus().text(this._surveyPaginatorData().labels.progression.replace('{status}', percentage));
		},
		prevPage: function () {
			var el = this;
			if (el._hasPrevious()) {
				this.changePage(false);
			}

			// if first page then refresh questions
			// this is needed in case the questions have been changed and
			// currently we are not showing params.questionsPerPage questions for the first page.
			if (!el._hasPrevious()) {
				el.refreshQuestions();
			}

			return this;
		},
		nextPage: function () {
			var el = this;
			var params = el._surveyPaginatorData();

			if (params.onChangingPage()) {
				if (el._hasNext()) {
					this.changePage(true);
				}
			}

			if (!el._hasNext()) {
				el.updateProgressControls(100);
			}

			return this;
		},
		showErrorPage: function () {
			var el = this;
			var paginatorControls = el.children('.survey-paginator-controls');
			var progressBar = el._progressBar(),
			    progressBarStatus = el._progressBarStatus();
			var params = el._surveyPaginatorData();
			var found = false;

			// hide currently shown questions
			el.hideQuestions();

			while (!found && el._hasNext()) {
				$.each(params.currentQuestions || [], function (idx, question) {
					// eslint-disable-line no-loop-func
					if ($(question).hasClass('has-error')) {
						found = true;
					}
				});

				// move to the next page if not found
				if (!found) {
					params.currentQuestions = el._nextQuestions();
				}
			}

			el.showQuestions();

			el.updatePaginationControls();

			progressBar.css('width', el._getStatusPercentage() + '%');
			progressBarStatus.text(params.labels.progression.replace('{status}', el._getStatusPercentage()));

			// add direct submit button in case when we have validation errors
			paginatorControls.children('.next_button').after('<a class="trustyou-ui btn btn-primary" id="submit">' + params.labels.submit + '</a>');
			paginatorControls.children('#submit').click(function () {
				submitReview();
			});
		},
		refresh: function () {
			var el = this;
			var params = el._surveyPaginatorData();
			var handleError = function (data) {
				el._toggleLoading(false);
				params.onError.call(el, data);
			};

			if (!el._isLoading()) {
				el._toggleLoading(true);

				el.renderer()
				// Success
				.done(function () {
					el._toggleLoading(false);

					// Callback
					params.onRendered.call(el);
				})
				// Fail
				.fail(handleError);
			}

			return this;
		},
		renderer: function () {
			var el = this;
			var params = el._surveyPaginatorData();
			var progressBar = el._progressBar();
			var questionMarkup = [];

			// add all sections to content
			$.each(params.surveyQuestionSections || [], function (_, questionSection) {
				questionMarkup.push($(questionSection));
			});

			$(questionMarkup).appendTo(el);

			$.tmpl(params.surveyPaginatorTmpl, {
				mobileDisplay: params.mobileDisplay,
				showProgressBarLabels: params.showProgressBarLabels,
				progression: params.labels.progression.replace('{status}', el._getStatusPercentage()),
				back: params.labels.back,
				next: params.labels.next,
				start: params.labels.start,
				finish: params.labels.finish,
				invalid_fields: params.labels.invalid_fields
			}).appendTo(el);

			$(params.submitSection).appendTo(el);

			this.initializeProgress();

			// Events
			var paginatorControls = el.children('.survey-paginator-controls');

			paginatorControls.children('.back_button').click(function () {
				el.prevPage();
			});

			paginatorControls.children('.next_button').click(function () {
				el.nextPage();
			});

			$('#' + params.navBarId).find('.back_button_top').click(function () {
				el.prevPage();
			});

			$('#' + params.navBarId).find('.next_button_top').click(function () {
				el.nextPage();
			});

			// calculate pages
			var questions = el._questions();

			// hide all questions except the current page
			$.each(questions || [], function (idx, question) {
				if (idx >= params.questionsPerPage) {
					el.hideQuestion(question);
				} else {
					params.currentQuestions.push(question);
				}
			});

			el.updatePaginationControls();

			progressBar.css('width', el._getStatusPercentage() + '%');

			return $.Deferred().resolve();
		},
		showQuestion: function (question) {
			var section = void 0;

			question = $(question);

			// handle the case of hidden custom questions, avoid showing empty sections
			var visibleChildren = question.children().filter(function () {
				return $(this).css('display') !== 'none';
			});

			if (visibleChildren.length > 0) {
				question.show();

				section = question.closest('.questions, .submit, .question_section');

				section.show();
			}
		},
		showQuestions: function () {
			var el = this;
			var params = el._surveyPaginatorData();

			$.each(params.currentQuestions || [], function (idx, question) {
				el.showQuestion(question);
			});
		},
		hideQuestion: function (question) {
			question = $(question);
			question.hide();

			var visibleQuestionSiblings = question.siblings('.question:not(.invisible-question):not(.parent_not_selected):visible');

			// hide subsection only if there are no other visible siblings
			if (!visibleQuestionSiblings.length) {
				var section = question.closest('.questions, .submit, .question_section');
				section.hide();
			}
		},
		hideQuestions: function () {
			var el = this;
			var params = el._surveyPaginatorData();

			// hide all currently visible questions
			// we take currentQuestions again from DOM since it might change as result of user interaction
			params.currentQuestions = el._currentQuestions();

			$.each(params.currentQuestions || [], function (idx, question) {
				el.hideQuestion(question);
			});
		},
		_questions: function () {
			// return only questions with visible content
			return this.find('.question:not(.invisible-question)').filter(function () {
				if (!$(this).hasClass('parent_not_selected')) {
					return true;
				} else {
					return false;
				}
			});
		},
		refreshQuestions: function () {
			var el = this,
			    questions = $(el._questions());
			var params = this._surveyPaginatorData();
			var questionCounter = 0,
			    index = void 0;

			// read again the currently visible questions
			params.currentQuestions = el._currentlyVisibleQuestions();

			if (params.currentQuestions && params.currentQuestions.length > 0) {
				index = questions.index(params.currentQuestions[0]);

				params.currentQuestions = params.currentQuestions.slice(0, 1);

				if (index !== -1) {
					params.currentQuestions = params.currentQuestions.toArray().concat(questions.filter(function (questionIdx) {
						// eslint-disable-line array-callback-return,consistent-return
						if (questionIdx > index) {
							if (questionCounter < params.questionsPerPage - 1) {
								questionCounter += 1;
								return true;
							} else {
								return false;
							}
						}
					}));

					el.showQuestions();

					// reset counter
					questionCounter = 0;

					// hide empty survey questions without visible content and elements with idx
					// greater than params.questionsPerPage

					$.each(el._currentQuestions() || [], function (idx, question) {
						var visibleChildren = $(question).children().filter(function () {
							return $(this).css('display') !== 'none';
						});

						if (!visibleChildren.length || questionCounter >= params.questionsPerPage) {
							el.hideQuestion(question);
						} else {
							questionCounter += 1;
						}
					});

					// update current questions
					params.currentQuestions = el._currentQuestions();

					// update controls to allow next on last page or previous on first page in case of new items
					el.updatePaginationControls();
				}
			}
		},
		_nextQuestions: function () {
			var _this = this;

			// eslint-disable-line consistent-return
			var questions = $(this._questions());
			var params = this._surveyPaginatorData();
			var questionCounter = 0,
			    index = void 0;
			if (params.currentQuestions && params.currentQuestions.length > 0) {
				index = questions.index(params.currentQuestions[params.currentQuestions.length - 1]);
				if (index !== -1) {
					// Save the current scroll position
					var currentScroll = $(window).scrollTop();
					var nextQuestions = questions.filter(function (questionIdx) {
						if (questionIdx > index) {
							if (questionCounter < params.questionsPerPage) {
								questionCounter += 1;
								return true;
							}
						}
						return false;
					});
					// Handle dependent questions
					nextQuestions.each(function (_, question) {
						var questionId = $(question).attr('id');
						if (questionId) {
							_this._updateDependentQuestionsVisibility(questionId);
						}
					});
					// Restore the scroll position after calculating next questions
					$(window).scrollTop(currentScroll);
					return nextQuestions;
				}
			}
		},
		_updateDependentQuestionsVisibility: function (parentQuestionId) {
			var dependentQuestions = TYAPP_SURVEYS.dependentQuestions.filter(function (dq) {
				return dq.parentQuestionIds.includes(parentQuestionId);
			});
			dependentQuestions.forEach(function (dependentQuestion) {
				var parentAnswersIdxs = dependentQuestion.parentAnswersIdxs || {};
				var dependentElement = $('#' + dependentQuestion.id + '-panel');
				var parentInputs = $('[name="' + parentQuestionId + '"]');
				var matches = false;
				if (parentInputs.is(':checkbox')) {
					var selectedValues = parentInputs.filter(':checked').map(function () {
						return parseInt($(this).val(), 10);
					}).get();
					matches = selectedValues.some(function (value) {
						return parentAnswersIdxs[parentQuestionId] && parentAnswersIdxs[parentQuestionId].includes(value);
					});
				} else if (parentInputs.is(':radio')) {
					var selectedValue = parseInt(parentInputs.filter(':checked').val(), 10);
					matches = parentAnswersIdxs[parentQuestionId] && parentAnswersIdxs[parentQuestionId].includes(selectedValue);
				} else {
					var _selectedValue = parseInt(parentInputs.val(), 10);
					matches = parentAnswersIdxs[parentQuestionId] && parentAnswersIdxs[parentQuestionId].includes(_selectedValue);
				}
				// Show or hide the dependent question based on the parent's answer
				if (matches) {
					dependentElement.show();
				} else {
					dependentElement.hide();
				}
			});
		},
		_previousQuestions: function () {
			// eslint-disable-line array-callback-return,consistent-return
			var questions = $(this._questions());
			var params = this._surveyPaginatorData();
			var previousQuestions = void 0,
			    index = void 0;

			if (params.currentQuestions && params.currentQuestions.length > 0) {
				index = questions.index(params.currentQuestions[0]);

				if (index !== -1) {
					previousQuestions = questions.filter(function (questionIdx) {
						return questionIdx < index;
					});

					// return last params.questionsPerPage questions before params.currentQuestion
					return previousQuestions.toArray().slice(Math.max(previousQuestions.length - params.questionsPerPage, 0));
				}
			}
		},
		_getStatusPercentage: function () {
			var questions = $(this._questions());
			var params = this._surveyPaginatorData();
			var index = void 0;

			if (params.currentQuestions && params.currentQuestions.length > 0) {
				index = questions.index(params.currentQuestions[0]);
			}

			return Math.round(index * 100 / questions.length) || 0;
		},
		_hasNext: function () {
			var questions = $(this._questions());
			var params = this._surveyPaginatorData();
			var index = void 0;

			if (params.currentQuestions && params.currentQuestions.length > 0) {
				index = questions.index(params.currentQuestions[params.currentQuestions.length - 1]);

				return index < questions.length - 1;
			} else {
				return false;
			}
		},
		_hasPrevious: function () {
			var questions = $(this._questions());
			var params = this._surveyPaginatorData();
			var index = void 0;

			if (params.currentQuestions && params.currentQuestions.length > 0) {
				index = questions.index(params.currentQuestions[0]);

				return index > 0;
			} else {
				return false;
			}
		},
		_currentQuestions: function () {
			return this.find('.question:not(.invisible-question):not(.parent_not_selected):visible');
		},
		_currentlyVisibleQuestions: function () {
			return this._currentQuestions().filter(function () {
				return $(this).css('display') !== 'none';
			});
		},
		_controls: function () {
			return this.children('.survey-paginator-controls');
		},
		_progressBar: function () {
			var params = this._surveyPaginatorData();
			return $('#' + params.navBarId).find('.bar-chart .value');
		},
		_progressBarStatus: function () {
			var params = this._surveyPaginatorData();
			return $('#' + params.navBarId).find('.progress-bar-status');
		},
		_isLoading: function () {
			return !!this._surveyPaginatorData().loading;
		},
		_toggleLoading: function (loading) {
			var params = this._surveyPaginatorData();
			var loadingPanel = this.children('.survey-paginator-loading');

			params.loading = loading;
			loadingPanel.toggle(loading);

			return this;
		},
		_surveyPaginatorData: function (data) {
			var dataAttr = 'surveyPaginatorInternal';

			if (data) {
				return this.data(dataAttr, data);
			} else {
				return this.data(dataAttr);
			}
		}
	};
})(jQuery);